import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/**
 * Loads joint-use functionalizations after the plugin-owned target is set.
 * A cancellation here means the target already had the requested ID, so it is
 * still safe to load from that target.
 */
export const loadForCurrentEntityOnTargetSet = store.effects.create(
  (feature: Plugin['feature'], _plugin: Plugin) =>
    rxjs
      .merge(
        feature.actions.setCurrentEntityTarget.success.observe(),
        feature.actions.setCurrentEntityTarget.cancellation.observe(),
      )
      .pipe(
        rxjs.map(action =>
          feature.actions.loadForCurrentEntity.request.from(action).create(),
        ),
      ),
)
